// extracted by mini-css-extract-plugin
module.exports = {"container":"httpError_container__1Hx9I","content":"httpError_content__2gmBQ","title":"httpError_title__8jGwV"};